var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifierFat = function SvgMagnifierFat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".magnifier_fat_svg__st0{fill:none;stroke:#231f20;stroke-width:4.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "magnifier_fat_svg__st0",
    cx: 21.3,
    cy: 20.3,
    r: 9.3,
    id: "magnifier_fat_svg__Layer_2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "magnifier_fat_svg__st0",
    d: "m27.7 27.2 8.6 8.6",
    id: "magnifier_fat_svg__Layer_5"
  })));
};
export default SvgMagnifierFat;